<template>
  <social-link :href="link" target="_blank" :fillcolor="color">
    <div class="wrapper">
      <svg viewBox="0 0 32 32" width="32" height="32">
      <title>logo instagram</title>
      <g :fill="color">
        <path :fill="color" d="M16,2.883c4.272,0,4.778,0.016,6.465,0.093c1.821,0.083,3.511,0.448,4.811,1.748 c1.3,1.3,1.665,2.99,1.748,4.811c0.077,1.687,0.093,2.193,0.093,6.465s-0.016,4.778-0.093,6.465 c-0.083,1.821-0.448,3.511-1.748,4.811c-1.3,1.3-2.99,1.665-4.811,1.748c-1.687,0.077-2.193,0.093-6.465,0.093 s-4.778-0.016-6.465-0.093c-1.821-0.083-3.511-0.448-4.811-1.748c-1.3-1.3-1.665-2.99-1.748-4.811 C2.899,20.778,2.883,20.272,2.883,16s0.016-4.778,0.093-6.465c0.083-1.821,0.448-3.511,1.748-4.811c1.3-1.3,2.99-1.665,4.811-1.748 C11.222,2.899,11.728,2.883,16,2.883 M16,0c-4.345,0-4.89,0.018-6.597,0.096c-2.6,0.119-4.884,0.756-6.718,2.589 c-1.833,1.833-2.47,4.117-2.589,6.718C0.018,11.11,0,11.655,0,16c0,4.345,0.018,4.89,0.096,6.597c0.119,2.6,0.756,4.884,2.589,6.718 c1.833,1.833,4.117,2.47,6.718,2.589C11.11,31.982,11.655,32,16,32s4.89-0.018,6.597-0.096c2.6-0.119,4.884-0.756,6.718-2.589 c1.833-1.833,2.47-4.117,2.589-6.718C31.982,20.89,32,20.345,32,16s-0.018-4.89-0.096-6.597c-0.119-2.6-0.756-4.884-2.589-6.718 c-1.833-1.833-4.117-2.47-6.718-2.589C20.89,0.018,20.345,0,16,0L16,0z"></path>
        <path :fill="color" data-color="color-2" d="M16,7.784c-4.538,0-8.216,3.679-8.216,8.216c0,4.538,3.679,8.216,8.216,8.216 s8.216-3.679,8.216-8.216C24.216,11.462,20.538,7.784,16,7.784z M16,21.333c-2.946,0-5.333-2.388-5.333-5.333 c0-2.946,2.388-5.333,5.333-5.333c2.946,0,5.333,2.388,5.333,5.333C21.333,18.946,18.946,21.333,16,21.333z"></path>
        <circle :fill="color" data-color="color-2" cx="24.541" cy="7.459" r="1.92"></circle>
      </g>
      </svg>
    </div>
  </social-link>
</template>

<script>
import { SocialLink } from '@/styles/components'

export default {
  components: {
    SocialLink
  },
  props: [
    'link',
    'color'
  ]
}
</script>
